"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsMedias = void 0;
const react_1 = __importDefault(require("react"));
const lazy_1 = __importDefault(require("react-player/lazy"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_serving_bs_lazy_render_1 = require("@hotelplan/core.serving.bs-lazy-render");
const core_basis_bs_link_1 = require("@hotelplan/core.basis.bs-link");
const VideoMediaWrap = styled_components_1.default.div({
    height: '100%',
    minHeight: '20vw',
});
const MusicMediaWrap = styled_components_1.default.div({
    position: 'relative',
    width: '100%',
    height: '100%',
});
const ExternalMediaLink = (0, styled_components_1.default)(core_basis_bs_link_1.BsLink)({ width: '100%', height: '100%' });
const PdfMediaLink = (0, styled_components_1.default)(ExternalMediaLink)({
    width: '100%',
    height: '100%',
});
const BsMedias = props => {
    const { className, isGallery, children } = props;
    let item = null;
    const { refEl, entered } = (0, core_serving_bs_lazy_render_1.useElementEnteredViewport)();
    switch (props.__typename) {
        case 'ImageMediaItem': {
            item = children;
            break;
        }
        case 'VideoMediaItem':
            item = (react_1.default.createElement(VideoMediaWrap, { ref: refEl, className: "video", "data-id": "slide-video" }, entered && (react_1.default.createElement(lazy_1.default, { playing: !isGallery, controls: isGallery, muted: !isGallery, url: props.resource, width: "100%", height: "100%" }))));
            break;
        case 'MusicMediaItem':
            item = (react_1.default.createElement(MusicMediaWrap, { ref: refEl, className: "music", "data-id": "music-media" },
                children,
                entered && (react_1.default.createElement(lazy_1.default, { playing: !isGallery, controls: isGallery, url: props.resource, width: "100%", height: "100%", style: {
                        position: 'absolute',
                        top: 0,
                    } }))));
            break;
        case 'ExternalMediaItem':
            item = (react_1.default.createElement(ExternalMediaLink, { className: "external", href: props.resource, "data-id": "external-media", target: "_blank" }, children));
            break;
        case 'PdfMediaItem':
            item = (react_1.default.createElement(PdfMediaLink, { className: "pdf", href: props.resource, "data-id": "pdf-media", target: "_blank" }, children));
            break;
        default:
            break;
    }
    return react_1.default.createElement("div", { className: className }, item);
};
exports.BsMedias = BsMedias;
//# sourceMappingURL=bs-medias.js.map